import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { TicketService } from 'src/app/services/ticket.service';
import { ApiAdapterService } from 'src/app/services/api-adapter.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { CategoryItem, SubCategoryItem, AssignedToTeamItem, TicketLogsItem, ResolutionTypeList, TicketStatusEnum } from 'src/app/interface/ticket';
import { firstValueFrom, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NzMessageService } from 'ng-zorro-antd/message';
import { VdiApprovalService } from 'src/app/services/vdi-approval.service';
import { ChangeDetectorRef } from '@angular/core';
import { VdiService } from 'src/app/services/vdi.service';

interface VmDetailEntry {
  key: string;
  value: any;
  display: string;
  isStructured: boolean;
}
@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.css']
})
export class TicketComponent implements OnInit, OnDestroy {
  // ✅ Fix: Subject for managing subscription cleanup (memory leak prevention)
  private destroy$ = new Subject<void>();

  // ⚠️ DEVELOPMENT OVERRIDE: Allow these users to access support features for testing
  // Remove this in production!
  private readonly DEV_SUPPORT_USERS = [
    'karl.li@gti.com.hk',
    'karl.li',
    'mike.ng@gti.com.hk',
    'mike.ng'
  ];

  @Output() isClose = new EventEmitter(); //关闭抽屉方法
  @Output() ticketSubmitted = new EventEmitter(); //新工单提交完成事件
  @Output() ticketClosed = new EventEmitter(); //工单关闭完成事件
  @Output() ticketAccepted = new EventEmitter(); //工单接受完成事件
  @Output() ticketApproved = new EventEmitter(); //VDI工单审批完成事件
  @Input() ticketId: number = 0; //组件传入id 用于当前ticket操作
  @Input() ticketGuid: string = ""; //组件传入Guid 用于获取当前ticket信息
  @Input() ticketInfo: any = {};
  @Input() categoryCode: string = '';
  @Input() subCategoryCode: string = '';
  @Input() isAddBtn: boolean = false;
  @Input() description: string = "";
  ticketForm!: FormGroup; //提交表单
  remarkForm!: FormGroup;
  originalticketForm!: any; //提交表单
  ticketNo: string = ""    //ticketNo 用于submit之后显示弹窗上
  isSubmitVisible: boolean = false; // submit提交之后显示弹窗
  isCancelVisible: boolean = false; //取消弹窗显示
  isClosed: boolean = false; //关闭弹窗显示
  isReassignTeam: boolean = false; //分配弹窗显示
  isReassignTicket: boolean = false; //分配弹窗显示
  userInfo = JSON.parse(localStorage.getItem("User") || '{}'); //获取当前登录用户信息，用于填充信息
  isSupport: boolean = false; //是否IT support - initialized to false, will be set properly in getTicketInfoByInfo
  fileList: any[] = []; //文件上传数组
  originalFileList: any[] = []; //原文件上传数组
  delFileList: any[] = [];//删除的文件
  assignedToTeamID = 0; //分配的team
  assignedToTeamIDParam: number = 0;
  isShowLog: boolean = false; //是否显示日志
  isLoading: boolean = false; //是否保存
  isButtonLoading: boolean = false //是否点击按钮
  isShowLoading: boolean = false; //打开ticket时是否显示加载
  isShowAcceptSubCategory: boolean = false;
  isShowChangeSubCategoryReassignLog: boolean = false;
  isShowReassignTicket: boolean = false;
  fileName: string = ""; //文件名称集合
  isFileChange: boolean = false //文件是否改变
  showEmailList: string = ""; //抄送email列表名字
  isShowPdf: boolean = false; //是否显示pdf
  pdfSrc: string = ""; //pdf显示路径
  pdfId: number = 0;//pdf ID 用於下載
  pdfName: string = "";//pdf Name 用於下載
  originalSubCategoryID: number = 0; //进来ticket时的原始subCategoryID
  deviceInfo: string = "";
  showDeviceInfo: any = {};
  listOfColumn = [
    {
      title: this.translate.instant('log.time'),
    },
    {
      title: this.translate.instant('log.role'),
    },
    {
      title: this.translate.instant('log.action'),
    },
  ]; // 日志列表显示
  logListOfData: TicketLogsItem[] = []; // 日志数据
  isShowAccept: boolean = false; //接受弹窗显示
  ticketStatusID: number = 0//ticket状态 0 新建  1 提交  2 接受  3 关闭
  ticketStatusEnum: TicketStatusEnum = {
    create: 0,
    submitted: 1,
    inProgress: 2,
    closed: 3,
    reassign: 4,
    cancel: 5
  }//状态对象枚举
  isClosedVisible: boolean = false; //是否关闭ticket弹窗显示
  isClosedTicket: boolean = false; //关闭ticket弹窗显示
  @Input() problemCategoryList: CategoryItem[] = [];//问题下拉列表
  problemSubCategoryList: SubCategoryItem[] = [];//子问题下拉列表
  @Input() resolutionTypeList: ResolutionTypeList[] = [];//问题下拉列表
  assignedToTeamList: AssignedToTeamItem[] = []; //assined team 列表
  assignedToTeamName: string = '';
  assignedToTeamNameChangeSubCategory: string = '';
  lang = localStorage.getItem('lang') || 'en' //语言
  private langChangeSubscription: any; // Track subscription for cleanup
  ccEmailList: any[] = [
  ]; //ccEmial 列表
  isClickEmail: boolean = false;//判断是否鼠标点击
  isMousemoveEmail: boolean = false;//判断是否鼠标移入
  timer: any = null; //計時器
  isNotSupportTeam: boolean = false; //其他supportteam打开
  isOperateAction: boolean = false;//是否操作Action
  isBackConfirm: boolean = false;//是否返回
  isBackConfirmClick: boolean = false;//是否返回
  isChangeProblemSubCategory: boolean = false;//是否修改了ProblemSubCategory，如果修改就不显示Ressign按钮
  isSaveTicket: boolean = false;//是否保存ticket
  remarkList: any[] = [];
  pendingRemarks: string[] = []; // ✅ Store remarks for new tickets before submission
  isHaveSupportTeamOperate: boolean = false;//是否supportTeam操作过了
  rowVersion: string = ""; //版本戳 用于防重复
  showApproveButton: boolean = false;
  isApprovingVdi: boolean = false;
  isCheckingApprovePermission: boolean = false;
  private _approvalStatus: string | null = null;

  // Getter and setter for approvalStatus to auto-reset cache when status changes
  get approvalStatus(): string | null {
    return this._approvalStatus;
  }

  set approvalStatus(value: string | null) {
    const oldValue = this._approvalStatus;
    const newValue = value ? value.trim() : null;

    // Only update if value actually changed
    if (oldValue !== newValue) {
      console.log('🔄 [Ticket] approvalStatus changing:', {
        old: oldValue,
        new: newValue,
        normalized: newValue?.toLowerCase()
      });
      this._approvalStatus = newValue;
      // Reset cache when approval status changes
      this.resetCreateVmButtonCache();
      // Trigger change detection to update UI
      this.cdr.detectChanges();
    }
  }
  approveButtonLabel: string = 'Approve';
  isApproveButtonDisabled: boolean = false;
  isApprovalStatusLoading: boolean = false;
  vmDetails: any = null;
  isVmDetailsLoading: boolean = false;
  vmDetailsError: string | null = null;
  isVmCreated: boolean = false;
  vmDetailEntries: VmDetailEntry[] = [];
  isCreateVmLoading: boolean = false; // Loading state for Create VM button
  isVmCreationInProgress: boolean = false; // Track if VM creation is in progress for modal display
  constructor(private fb: FormBuilder, private ticketService: TicketService, private apiAdapter: ApiAdapterService, private translate: TranslateService, private message: NzMessageService, private vdiApprovalService: VdiApprovalService, private vdiService: VdiService, private cdr: ChangeDetectorRef) {
    // Subscribe to language changes to update lang property reactively
    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: any) => {
      console.log('🌐 [Ticket] Language changed to:', event.lang);
      this.lang = event.lang;
      localStorage.setItem('lang', event.lang);
      // Update form values that depend on language
      this.updateFormLanguageValues();
    });
  }

  // Update form values when language changes
  private updateFormLanguageValues(): void {
    console.log('🌐 [Ticket] updateFormLanguageValues() called - lang:', this.lang);
    if (this.ticketForm) {
      // Update category name
      const categoryID = this.ticketForm.get('categoryID')?.value;
      if (categoryID) {
        const category = this.problemCategoryList.find(cat => cat.id === categoryID);
        if (category) {
          const categoryName = this.lang == 'en' ? category.categoryDescrEng : category.categoryDescrChi;
          this.ticketForm.get('categoryName')?.setValue(categoryName || '');
        }
      }

      // Update subcategory name
      const subCategoryID = this.ticketForm.get('subCategoryID')?.value;
      if (subCategoryID) {
        const subCategory = this.problemSubCategoryList.find(sub => sub.id === subCategoryID);
        if (subCategory) {
          const subCategoryName = this.lang == 'en' ? subCategory.subCategoryDescrEng : subCategory.subCategoryDescrChi;
          this.ticketForm.get('subCategoryName')?.setValue(subCategoryName || '');
        }
      }

      // Update resolution type name
      const resolutionTypeID = this.ticketForm.get('resolutionTypeID')?.value;
      if (resolutionTypeID) {
        const resolutionType = this.resolutionTypeList.find(rt => rt.id === resolutionTypeID);
        if (resolutionType) {
          const resolutionTypeName = this.lang == 'en' ? resolutionType.resolutionTypeDescrEng : resolutionType.resolutionTypeDescrChi;
          this.ticketForm.get('resolutionTypeName')?.setValue(resolutionTypeName || '');
        }
      }
    }
  }
  ngOnInit(): void {
    this.initTicketInfo();

    if (this.ticketId) {
      this.isShowLoading = true;
      //列表进来的信息先回显
      this.getTicketInfoByInfo(this.ticketInfo);
      //获取User信息调接口
      this.getTicketById();
      this.getFilesById();
      this.showRemark();
      this.getApprovalDetails();
      this.loadVmDetails('ngOnInit');
    } else {
      // Load categories for new ticket creation
      this.getProblemCategory();

      //URL创新新ticket回显categoryCode和subCategoryCode
      if (!this.isAddBtn && this.categoryCode) {
        this.ticketService.getCategoryIDByCode(this.categoryCode, this.subCategoryCode)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (res) => {
              // Load subcategories for the selected category
              if (res.categoryID > 0) {
                this.getProblemSubCategory(parseInt(res.categoryID));
              }
              if (res.subCategoryID > 0) {
                this.ticketForm.get('subCategoryID')?.setValue(parseInt(res.subCategoryID));
              }
            },
            error: (error) => {
              console.error('Error getting category ID by code: ', error);
            }
          })
        if (this.description) {
          this.ticketForm.get('detail')?.setValue(this.description);
        }
      }

      // For new tickets, determine if user is support based on their role
      this.isSupport = this.userInfo.supportTeam && this.userInfo.supportTeam.length > 0;

      // ✅ Fix: Update form validators based on isSupport for new tickets
      // This is needed because form was created in initTicketInfo() before isSupport was set
      if (this.isSupport) {
        const severityControl = this.ticketForm.get('severityLevel');
        const resolutionTypeControl = this.ticketForm.get('resolutionTypeID');
        const actualTimeControl = this.ticketForm.get('actualTimeSpent');
        const resolutionCommentsControl = this.ticketForm.get('resolutionComments');

        severityControl?.setValidators([Validators.required]);
        resolutionTypeControl?.setValidators([Validators.required]);
        actualTimeControl?.setValidators([Validators.required]);
        resolutionCommentsControl?.setValidators([Validators.required]);

        severityControl?.updateValueAndValidity();
        resolutionTypeControl?.updateValueAndValidity();
        actualTimeControl?.updateValueAndValidity();
        resolutionCommentsControl?.updateValueAndValidity();
      }
    }
    this.getCCToEmailList();
  }

  //获取抄送email列表
  getCCToEmailList(): void {
    this.ticketService.getMailList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          res.data.forEach((mailItem: any) => {
            if (mailItem.email) {
              this.ccEmailList.push(mailItem.email)
            }
          })
        },
        error: (error) => {
          console.error('Error getting mail list: ', error);
        }
      })
  }

  //获取问题类型列表
  getProblemCategory(): void {
    console.log('🔍 [Ticket Component] Loading categories...');
    this.ticketService.getProblemCategory()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          console.log('🔍 [Ticket Component] Received category response:', res);
          console.log('🔍 [Ticket Component] Response data:', res.data);
          console.log('🔍 [Ticket Component] Data length:', res.data?.length);
          this.problemCategoryList = res.data;
          console.log('🔍 [Ticket Component] Set problemCategoryList to:', this.problemCategoryList);

          // 🔄 Force UI update by triggering change detection
          // This ensures mat-select dropdown re-renders with new translations
          setTimeout(() => {
            this.cdr.detectChanges();
            console.log('✅ [Ticket Component] Forced UI update for categories');

            // Alternative: Force re-render by changing array reference
            this.problemCategoryList = [...this.problemCategoryList];
            console.log('✅ [Ticket Component] Force re-render with new array reference');
          }, 0);
        },
        error: (error) => {
          console.error('Error getting problem category: ', error);
        }
      })
  }

  //处理类别选择变化
  onCategoryChange(event: any): void {
    const categoryId = event.value;
    console.log('🔍 [Ticket Component] Category changed to:', categoryId);
    if (categoryId) {
      this.getProblemSubCategory(categoryId, true);
      // Ensure category name is updated when category changes
      const category = this.problemCategoryList.find(cat => cat.id === categoryId);
      if (category) {
        const categoryName = this.lang == 'en' ? category.categoryDescrEng : category.categoryDescrChi;
        this.ticketForm.get('categoryName')?.setValue(categoryName || '');
      }
    } else {
      this.problemSubCategoryList = [];
      this.ticketForm.get('subCategoryID')?.setValue(0);
      this.ticketForm.get('categoryName')?.setValue('');
    }
  }

  //获取子问题类型-根据问题id
  getProblemSubCategory(id: number | null | undefined, isChange?: boolean): void {
    if (!id) {
      console.warn('Category ID is undefined when loading subcategories');
      return;
    }
    console.log('🔍 [Ticket Component] Making API call to get subcategories for category ID:', id);
    this.ticketService.getProblemSubCategory(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          console.log('🔍 [Ticket Component] API call successful - Received subcategory response:', res);
          console.log('🔍 [Ticket Component] Response data:', res.data);
          console.log('🔍 [Ticket Component] Data length:', res.data?.length);
          console.log('🌐 [Ticket Component] Current lang:', this.lang, '(should be "en" or "zh-HK")');
          console.log('📊 [Ticket Component] First subcategory sample:', res.data?.[0]);
          console.log('📊 [Ticket Component] First subcategory Eng:', res.data?.[0]?.subCategoryDescrEng);
          console.log('📊 [Ticket Component] First subcategory Chi:', res.data?.[0]?.subCategoryDescrChi);
          this.problemSubCategoryList = res.data;
          console.log('🔍 [Ticket Component] Set problemSubCategoryList to:', this.problemSubCategoryList);

          // 🔄 Force UI update by triggering change detection
          // This ensures mat-select dropdown re-renders with new translations
          setTimeout(() => {
            this.cdr.detectChanges();
            console.log('✅ [Ticket Component] Forced UI update for subcategories');

            // Alternative: Force re-render by changing array reference
            this.problemSubCategoryList = [...this.problemSubCategoryList];
            console.log('✅ [Ticket Component] Force re-render with new array reference');
          }, 0);

        if (isChange) {
          this.ticketForm.get('subCategoryID')?.setValue(0);
        }
      },
      error: (error) => {
        console.error('🔍 [Ticket Component] API call failed - Error getting problem sub-category: ', error);
      }
    })
  }
  //获取ticket详情信息
  getTicketById(): void {
    this.ticketService.getTicketInfo(this.ticketGuid)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.rowVersion = res?.ticket?.rowVersion || '';
          this.getTicketInfoByInfo(res);
          this.isShowLoading = false; // ✅ Fix: Set loading to false when ticket is loaded
        },
        error: (error) => {
          console.error('Error getting ticket info: ', error);
          this.isShowLoading = false; // ✅ Fix: Set loading to false on error as well
        }
      })
  }
  getTicketInfoByInfo(ticketInfo: any): void {
    this.ticketInfo = ticketInfo;
    let res = ticketInfo;
    let findTeam = this.userInfo.supportTeam.find((team: any) => {
      return team.teamID == res.ticket?.assignedToTeamID
    })

    console.log('🔍 [Ticket Component] --- getTicketInfoByInfo called ---');
    console.log('🔍 [Ticket Component] Ticket data:', res);
    console.log('🔍 [Ticket Component] Ticket ticket object:', res.ticket);
    console.log('🔍 [Ticket Component] Category ID:', res.ticket?.categoryID);
    console.log('🔍 [Ticket Component] Subcategory ID:', res.ticket?.subCategoryID);

    // Always load subcategories based on category ID if available
    const categoryId = res.ticket?.subCategory?.categoryID;
    if (categoryId) {
      console.log('🔍 [Ticket Component] Calling getProblemSubCategory with category ID:', categoryId);
      this.getProblemSubCategory(categoryId);
    } else {
      console.warn('🔍 [Ticket Component] No category ID found for ticket:', res.ticket?.id);
      this.problemSubCategoryList = [];
    }

    // Set subcategory ID value
    if (res.ticket?.subCategoryID > 0) {
      console.log('🔍 [Ticket Component] Setting subcategory ID value:', res.ticket.subCategoryID);
      this.ticketForm.get('subCategoryID')?.setValue(parseInt(res.ticket.subCategoryID));
    } else {
      console.log('🔍 [Ticket Component] No subcategory ID found, setting to 0');
      this.ticketForm.get('subCategoryID')?.setValue(0);
    }
    // ✅ Fix: Correct isSupport logic
    // User is support if they belong to any support team (regardless of ticket creator)
    const userHasSupportTeam = this.userInfo.supportTeam && this.userInfo.supportTeam.length > 0;
    // User can operate on ticket if they're in support AND ticket is assigned to their team
    const isInAssignedTeam = !!findTeam;

    if (userHasSupportTeam && isInAssignedTeam) {
      this.isSupport = true;  // Full support access
    } else if (userHasSupportTeam && !isInAssignedTeam) {
      this.isSupport = true;  // Support user (can see buttons but limited)
    } else {
      this.isSupport = false; // Not a support team member
    }
    this.ticketStatusID = res.ticket?.ticketStatusID;
    console.log('🔍 ========== [TICKET DEBUG] ==========');
    console.log('🔍 isSupport:', this.isSupport);
    console.log('🔍 ticketStatusID:', this.ticketStatusID, '(inProgress=2, reassign=4)');
    console.log('🔍 userHasSupportTeam:', userHasSupportTeam);
    console.log('🔍 isInAssignedTeam:', isInAssignedTeam);
    console.log('🔍 Close button should show:', this.isSupport && (this.ticketStatusID === 2 || this.ticketStatusID === 4));
    console.log('🔍 =====================================');

    // ✅ Fix: Refresh userInfo from localStorage to get latest supportTeam
    // This is needed because supportTeam is loaded asynchronously after login
    const storedUser = localStorage.getItem('User');
    const localIsSupport = localStorage.getItem('isSupport');
    console.log('🔍 [Ticket] localStorage isSupport:', localIsSupport);
    console.log('🔍 [Ticket] localStorage User:', storedUser ? JSON.parse(storedUser) : 'null');

    if (storedUser) {
      const freshUserInfo = JSON.parse(storedUser);
      this.userInfo = { ...this.userInfo, ...freshUserInfo };
      console.log('🔍 [Ticket] userInfo.supportTeam after refresh:', this.userInfo.supportTeam);
    }

    // Re-calculate isSupport with fresh userInfo
    const freshUserHasSupportTeam = this.userInfo.supportTeam && this.userInfo.supportTeam.length > 0;

    // Check if user is admin (can manage all tickets regardless of support team)
    const userEmail = this.userInfo.email || this.userInfo.userPrincipalName || '';
    const userName = this.userInfo.name || this.userInfo.displayName || '';
    const userRoles = this.userInfo.roles || [];

    // Admin check: has Admin role OR specific admin emails
    const adminEmails = ['karl.li@gti.com.hk', 'mike.ng@gti.com.hk', 'admin@gti.com.hk', 'admin'];
    const isAdmin = userRoles.includes('Admin') ||
                    userRoles.includes('admin') ||
                    userRoles.includes('Administrator') ||
                    adminEmails.some(email => userEmail.toLowerCase().includes(email.toLowerCase()));

    // Dev override users
    const isDevOverrideUser = this.DEV_SUPPORT_USERS.some(devUser =>
      userEmail.toLowerCase().includes(devUser.toLowerCase()) ||
      userName.toLowerCase().includes(devUser.toLowerCase())
    );

    console.log('🔍 [Ticket] userRoles:', userRoles);
    console.log('🔍 [Ticket] isAdmin:', isAdmin);

    // Priority: 1) Admin user, 2) supportTeam in userInfo, 3) localStorage isSupport flag, 4) Dev override
    if (isAdmin) {
      this.isSupport = true;
      console.log('🔍 [Ticket] ✅ isSupport = TRUE (user is Admin)');
    } else if (freshUserHasSupportTeam) {
      this.isSupport = true;
      console.log('🔍 [Ticket] ✅ isSupport = TRUE (supportTeam found in userInfo)');
    } else if (localIsSupport === 'true') {
      this.isSupport = true;
      console.log('🔍 [Ticket] ✅ isSupport = TRUE (from localStorage isSupport flag)');
    } else if (isDevOverrideUser) {
      // ⚠️ DEVELOPMENT OVERRIDE: Allow specific users for testing
      this.isSupport = true;
      console.log('🔍 [Ticket] ✅ isSupport = TRUE (DEV OVERRIDE for user:', userEmail, ')');
    } else {
      console.log('🔍 [Ticket] ❌ isSupport = FALSE (no support access found)');
    }

    console.log('🔍 [Ticket] Final isSupport:', this.isSupport);
    console.log('🔍 [Ticket] Final ticketStatusID:', this.ticketStatusID);
    console.log('🔍 [Ticket] Close button should show:', this.isSupport && (this.ticketStatusID === 2 || this.ticketStatusID === 4));
    console.log('🔍 =====================================');
    // Note: isShowLoading will be set to false AFTER patchValue (below) to ensure instant display
    this.isLoading = false; // ✅ Fix: Reset button loading state when ticket is loaded
    this.originalSubCategoryID = res.ticket?.subCategory.id;
    this.ticketNo = res.ticket?.ticketNo;

    // ✅ Fix: Set ticketId from loaded ticket data (required for VDI Approval Status component)
    if (res.ticket?.id && !this.ticketId) {
      this.ticketId = res.ticket.id;
      console.log('✅ [Ticket] Set ticketId from loaded ticket:', this.ticketId);
    }

    // Reset VDI ticket cache when new ticket data is loaded
    this.resetVDITicketCache();
    // Note: isVmCreated will be set by loadVmDetails() based on actual VM details

    this.deviceInfo = res.ticket?.clientInfo;

    try {
      this.showDeviceInfo = this.deviceInfo ? JSON.parse(this.deviceInfo) : {};
    } catch (error) {
      console.warn('Client info is not JSON.', this.deviceInfo);
      this.showDeviceInfo = {};
    }
    this.assignedToTeamIDParam = res.ticket?.assignedToTeamID;

    // Use patchValue to update form without recreating it (fixes delay in displaying values)
    this.ticketForm.patchValue({
      id: res.ticket?.id,
      ticketNo: res.ticket?.ticketNo,
      categoryID: res.ticket?.subCategory?.categoryID || res.ticket?.categoryID || res.ticket?.category?.id,
      ticketStatusID: res.ticket?.ticketStatusID,
      fullName: res.user?.displayName,
      email: res.user?.mail,
      contactNo: res.ticket?.contactNo == 'null' ? '' : res.ticket?.contactNo || "",
      submittedDate: res.ticket?.submittedDate,
      subCategoryName: this.lang == 'en' ? res.ticket?.subCategory?.subCategoryDescrEng : res.ticket?.subCategory?.subCategoryDescrChi,
      detail: res.ticket?.detail,
      severityLevel: res.ticket?.severityLevel || 3,
      resolutionTypeID: res.ticket?.resolutionTypeID,
      resolutionTypeName: this.lang == 'en' ? res.ticket?.resolutionType?.resolutionTypeDescrEng : res.ticket?.resolutionType?.resolutionTypeDescrChi,
      actualTimeSpent: res.ticket?.actualTimeSpent,
      resolutionComments: res.ticket?.resolutionComments,
      courseLecturer: res.ticket?.courseLecturer || "",
      acceptedUser: res.acceptedByName || '',
      acceptedDate: res.ticket?.acceptedDate ? new Date(res.ticket?.acceptedDate) : '',
      firstAcceptedUser: res.firstAcceptedByName || '',
      firstAcceptedDate: res.ticket?.firstAcceptedDate ? new Date(res.ticket?.firstAcceptedDate) : '',
      closedUser: res.closedByName || '',
      closedDate: res.ticket?.closedDate ? new Date(res.ticket?.closedDate) : '',
      createdDate: res.ticket?.createdDate || '',
      createdUser: res.ticket?.createdUser || '',
      assignedToTeamID: res.ticket?.assignedToTeamID || 0,
      assignedToTeamName: res.ticket?.assignedToTeam?.name || '',
      firstAssignedToTeamID: res.ticket?.firstAssignedToTeamID || 0,
      categoryName: this.lang == 'en' ? (res.ticket?.subCategory?.category?.categoryDescrEng || res.ticket?.category?.categoryDescrEng || '') : (res.ticket?.subCategory?.category?.categoryDescrChi || res.ticket?.category?.categoryDescrChi || ''),
      firstAssignedToTeamName: res.ticket?.firstAssignedToTeam?.name || '',
    });

    // ✅ Fix: Set isShowLoading to false AFTER form is populated to ensure instant data display
    this.isShowLoading = false;
    // ✅ Fix: Trigger change detection immediately to update the view without delay
    this.cdr.detectChanges();

    // SubCategory is already loaded from the ticket data
    if (res.ticket?.ticketEmailCCs && res.ticket?.ticketEmailCCs.length > 0) {
      let emailList: string[] = [];
      this.showEmailList = '';
      res.ticket?.ticketEmailCCs.forEach((value: any) => {
        this.showEmailList = value.email + ";" + this.showEmailList;
        emailList.push(value.email);
      })
      this.ticketForm.get('emailCC')?.setValue(emailList)
    }

    // ✅ Fix: Ensure validators are set correctly based on isSupport
    // This is needed because isSupport might not be set correctly during form initialization
    const severityControl = this.ticketForm.get('severityLevel');
    const resolutionTypeControl = this.ticketForm.get('resolutionTypeID');
    const actualTimeControl = this.ticketForm.get('actualTimeSpent');
    const resolutionCommentsControl = this.ticketForm.get('resolutionComments');

    // Clear existing validators first
    severityControl?.clearValidators();
    resolutionTypeControl?.clearValidators();
    actualTimeControl?.clearValidators();
    resolutionCommentsControl?.clearValidators();

    // Set validators based on isSupport
    if (this.isSupport) {
      severityControl?.setValidators([Validators.required]);
      resolutionTypeControl?.setValidators([Validators.required]);
      actualTimeControl?.setValidators([Validators.required]);
      resolutionCommentsControl?.setValidators([Validators.required]);
    }

    // Update form validity
    severityControl?.updateValueAndValidity();
    resolutionTypeControl?.updateValueAndValidity();
    actualTimeControl?.updateValueAndValidity();
    resolutionCommentsControl?.updateValueAndValidity();

    this.originalticketForm = JSON.parse(JSON.stringify(this.ticketForm.value));
    this.evaluateApproveButtonState();
    this.loadVmDetails('getTicketInfoByInfo');

    // NOTE: Do NOT reset _justApproved flag here
    // The flag is managed by:
    // 1. approveVdiTicket() - sets it to true
    // 2. Safety timeout (5 seconds) in approveVdiTicket() - resets it
    // This prevents race conditions where getTicketInfoByInfo() runs before getApprovalDetails() completes
    if (this._justApproved) {
      console.log('⏳ [Ticket] _justApproved flag is still active (will be reset by safety timeout)');
    }
  }

  // Flag to track if approval just completed (prevents status overwrite during refresh)
  private _justApproved: boolean = false;

  private evaluateApproveButtonState(): void {
    const previousStatus = this.approvalStatus;

    // Hide approve button by default until checks complete
    this.showApproveButton = false;
    this.isCheckingApprovePermission = false;
    this.isApprovalStatusLoading = false;

    const hasTicketId = this.ticketId > 0;
    const awaitingApproval = this.ticketStatusID === this.ticketStatusEnum['submitted'];
    const isVdiTicket = this.isVDITicket();
    const shouldInvokeApprovalCheck = hasTicketId && awaitingApproval && isVdiTicket;

    console.log('🧾 [Ticket] VDI approval condition snapshot', {
      ticketId: this.ticketId,
      ticketStatusID: this.ticketStatusID,
      hasTicketId,
      awaitingApproval,
      isVdiTicket,
      shouldInvokeApprovalCheck
    });

    console.log('🧮 [Ticket] Approve button prerequisites', {
      hasTicketId,
      awaitingApproval,
      isVdiTicket,
      ticketStatusEnum: this.ticketStatusEnum
    });

    console.log('🔍 [Ticket] Detailed approval button conditions', {
      ticketId: this.ticketId,
      ticketStatusID: this.ticketStatusID,
      ticketStatus: this.getStatus(this.ticketStatusID),
      hasTicketId,
      awaitingApproval: awaitingApproval ? 'YES' : 'NO',
      isVdiTicket: isVdiTicket ? 'YES' : 'NO',
      shouldInvokeApprovalCheck: shouldInvokeApprovalCheck ? 'YES' : 'NO',
      currentApprovalStatus: this.approvalStatus || 'null'
    });

    console.log('🔍 [Ticket] showApproveButton state before evaluation:', {
      showApproveButton: this.showApproveButton,
      isCheckingApprovePermission: this.isCheckingApprovePermission,
      isApprovalStatusLoading: this.isApprovalStatusLoading
    });

    if (!hasTicketId || !isVdiTicket) {
      console.log('🚫 [Ticket] Skipping approval check (missing ticket or not VDI).', {
        hasTicketId,
        isVdiTicket,
        ticketId: this.ticketId,
        ticketStatusID: this.ticketStatusID
      });
      this.approvalStatus = previousStatus;
      this.updateApproveButtonUi();
      return;
    }

    if (!awaitingApproval) {
      console.log('⏳ [Ticket] Ticket not awaiting approval, skipping can-approve call.', {
        awaitingApproval,
        ticketStatusID: this.ticketStatusID,
        currentStatus: this.getStatus(this.ticketStatusID)
      });
      // Preserve approved status if we just approved and the status hasn't changed
      if (this._justApproved && previousStatus === 'Approved') {
        this.approvalStatus = 'Approved';
      } else {
        this.approvalStatus = previousStatus || this.approvalStatus;
      }
      this.updateApproveButtonUi();
      return;
    }

    // Don't reset approvalStatus if we just approved (prevents race condition)
    if (!this._justApproved) {
      this.approvalStatus = null;
    }
    this.updateApproveButtonUi();
    this.isCheckingApprovePermission = true;
    console.log('📡 [Ticket] Checking VDI approval permissions via API...');
    this.vdiApprovalService.canUserApproveTickets()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (canApprove) => {
          console.log('✅ [Ticket] canUserApproveTickets response', { canApprove });
          this.showApproveButton = canApprove;
          console.log('🔍 [Ticket] showApproveButton state after permission check:', {
            showApproveButton: this.showApproveButton,
            canApprove: canApprove,
            isCheckingApprovePermission: this.isCheckingApprovePermission
          });
          this.isCheckingApprovePermission = false;
          if (canApprove) {
            this.getApprovalDetails();
          }
        },
        error: (error) => {
          console.error('Error checking VDI approval permissions:', error);
          this.showApproveButton = false;
          this.isCheckingApprovePermission = false;
          console.log('❌ [Ticket] Failed to verify approval permissions, hiding button.');
        }
      })
  }

  private updateApproveButtonUi(): void {
    const status = (this.approvalStatus || '').trim().toLowerCase();
    console.log("updateApproveButtonUi is triggered")
    if (status === 'approved') {
      this.approveButtonLabel = 'Approved';
      this.isApproveButtonDisabled = true;
    } else {
      this.approveButtonLabel = 'Approve';
      this.isApproveButtonDisabled = false;
    }
  }

  getApprovalDetails(): void {
    console.log('🔍 [Ticket Component] Fetching approval status for ticketNo:', this.ticketNo);
    if (!this.ticketNo) {
      this.approvalStatus = null;
      this.updateApproveButtonUi();
      return;
    }

    // Only fetch VDI approval details for VDI tickets, not AVD tickets
    if (!this.isVDITicket()) {
      console.log('🔍 [Ticket Component] Skipping VDI approval check for non-VDI ticket');
      this.approvalStatus = null;
      this.isApprovalStatusLoading = false;
      this.updateApproveButtonUi();
      return;
    }

    this.isApprovalStatusLoading = true;

    this.vdiApprovalService.getApprovalDetails(this.ticketNo)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (approval) => {
          // If we just approved, only update status if backend confirms it
          // Otherwise keep our optimistic 'Approved' state
          if (this._justApproved) {
            const backendStatus = approval?.approvalStatus || '';
            if (backendStatus.trim().toLowerCase() === 'approved') {
              this.approvalStatus = 'Approved';
              console.log('✅ [Ticket Component] Backend confirmed approval status');
            } else {
              console.log('⏳ [Ticket Component] Backend not yet updated, keeping optimistic state');
              // Keep the optimistic 'Approved' status - DO NOT clear it
              // This prevents the button from reverting to "Approve"
            }
          } else {
            this.approvalStatus = approval?.approvalStatus || null;
          }
          console.log('🔍 [Ticket Component] Approval status', this.approvalStatus);
          this.isApprovalStatusLoading = false;
          this.updateApproveButtonUi();

          // Force change detection to ensure UI updates immediately
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error getting VDI approval status:', error);
          // Don't clear approval status if we just approved and the fetch fails
          // This preserves the optimistic 'Approved' state even if backend call fails
          if (!this._justApproved) {
            this.approvalStatus = null;
          } else {
            console.log('⏳ [Ticket Component] Fetch failed but keeping optimistic approved state');
          }
          this.isApprovalStatusLoading = false;
          this.updateApproveButtonUi();

          // Force change detection to ensure UI updates immediately
          this.cdr.detectChanges();
        }
      });
  }

  approveVdiTicket(): void {
    if (!this.ticketId || this.isApprovingVdi) {
      return;
    }

    this.isApprovingVdi = true;

    this.vdiApprovalService.approveTicket(String(this.ticketId), {
      comments: (this.ticketForm?.get('resolutionComments')?.value?.trim() || 'Ticket approved from ticket page'),
      vmSize: undefined,
      region: undefined
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          const successMessage = response?.message || 'VDI request approved successfully';
          this.message.success(successMessage);

          // Set flag to preserve approved state during refresh (prevents race condition)
          this._justApproved = true;

          // Optimistic UI update - set approved state immediately
          this.approvalStatus = 'Approved';
          this.updateApproveButtonUi();

          // Reset VDI ticket cache (but NOT Create VM button cache yet)
          this.resetVDITicketCache();

          // Force immediate UI update
          this.cdr.markForCheck();
          this.cdr.detectChanges();

          // Emit ticketApproved event to trigger parent list refresh
          console.log('✅ [Ticket] Emitting ticketApproved event');
          this.ticketApproved.emit();

          // Start polling for VM creation immediately
          console.log('🔄 [Ticket] Starting VM creation poll after approval');
          this.pollForVmCreation();

          // Wait for backend to process, then do complete refresh
          setTimeout(() => {
            // Fetch fresh approval status from backend to confirm
            this.getApprovalDetails();

            // Refresh full ticket data to get latest state
            // This will call loadVmDetails() which updates isVmCreated
            this.getTicketById();

            // Refresh files and remarks
            this.getFilesById();
            this.showRemark();

            // Force complete re-render after all data is loaded
            // Use a longer timeout to ensure loadVmDetails() completes
            setTimeout(() => {
              // NOW reset the Create VM button cache AFTER loadVmDetails() has updated isVmCreated
              this.resetCreateVmButtonCache();

              this.cdr.markForCheck();
              this.cdr.detectChanges();

              // Additional force: trigger re-evaluation of approve button state
              this.evaluateApproveButtonState();

              console.log('✅ [Ticket] Complete re-render triggered after approval');
              this.isApprovingVdi = false;
            }, 800);
          }, 300);

          // Safety timeout: Reset _justApproved flag after 5 seconds regardless of backend state
          // This ensures the flag doesn't get stuck if backend never confirms
          setTimeout(() => {
            if (this._justApproved) {
              console.log('⏰ [Ticket] Safety timeout: Resetting _justApproved flag after 5 seconds');
              this._justApproved = false;
              // At this point, we trust the backend state or keep current UI state
            }
          }, 5000);
        },
        error: (error) => {
          let errorMessage = 'Failed to approve VDI request';

          if (error?.status === 403) {
            errorMessage = 'You do not have permission to approve this VDI request.';
          } else if (error?.status === 401) {
            errorMessage = 'Please sign in to approve VDI requests.';
          } else if (error?.error?.message) {
            errorMessage = error.error.message;
          } else if (error?.message) {
            errorMessage = error.message;
          }

          this.message.error(errorMessage);
          this.isApprovingVdi = false;
          this.evaluateApproveButtonState();
        }
      });
  }
  //获取文件列表
  getFilesById(): void {
    this.ticketService.getAttachmentsByID(this.ticketId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
        this.fileList = res.data;
        this.originalFileList = JSON.parse(JSON.stringify(res.data));
        this.fileList.forEach((file) => {
          // Use the uri from backend response for image preview
          if (file.fileMimeType && file.fileMimeType.startsWith('image/')) {
            file.showImage = file.uri;
          } else if (file.fileMimeType === 'application/pdf') {
            file.showImage = file.uri;
          } else {
            // For non-image files, still need to download for preview/download functionality
            this.getFileById(file.id);
          }
        })
        this.showFileName();
      },
      error: (error) => {
        console.error('Error getting attachments by ID: ', error);
      }
    })
  }
  //显示文件集合名称
  showFileName(): void {
    this.fileName = "";
    for (let val of this.fileList) {
      this.fileName = val.originalFileName + ";" + this.fileName;
    }
  }
  //初始化ticket信息
  initTicketInfo() {
    // Clear pending remarks when initializing a new ticket
    this.pendingRemarks = [];

    this.ticketForm = this.fb.group({
      id: [0],
      ticketNo: [""],
      ticketStatusID: [0],
      fullName: [this.userInfo.displayName],
      email: [this.userInfo.mail],
      contactNo: ['', this.ticketStatusID == 0 ? [Validators.required] : ''],
      submittedDate: [new Date()],
      categoryID: ['', [Validators.required]],
      subCategoryID: ['', [Validators.required]],
      subCategoryName: [''],
      emailCC: [[]],
      detail: ['', [Validators.required]],
      severityLevel: [3],
      resolutionTypeID: [null],
      resolutionTypeName: [''],
      actualTimeSpent: [''],
      resolutionComments: [''],
      acceptedUser: [''],
      acceptedDate: [''],
      firstAcceptedUser: [''],
      firstAcceptedDate: [''],
      closedUser: [''],
      closedDate: [''],
      createdDate: [''],
      createdUser: [''],
      assignedToTeamID: [0],
      firstAassignedToTeamID: [0],
      categoryName: [''],
      courseLecturer: ['']
    });

    // Ensure category name is always set to prevent undefined values
    this.ticketForm.get('categoryName')?.setValue(this.ticketForm.get('categoryName')?.value || '');
    this.remarkForm = this.fb.group({
      remark: ['']
    })
  }
  //返回到列表页面（相当于关闭ticket）
  back(isBack?: boolean, isSubmit?: boolean) {
    if (!isBack && (this.ticketStatusID == 0 ? this.ticketForm.dirty : this.saveFromDirty() || this.isFileChange) && !isSubmit) {
      this.isBackConfirm = true;
      return;
    }
    this.isClose.emit();
  }
  //提交或保存ticket
  async saveForm() {
    // ✅ Capture remark value at the START before any form processing
    const remarkControl = this.remarkForm.get('remark');
    const initialRemarkValue = remarkControl?.value?.trim() || '';

    this.isLoading = true;
    // Get the selected subcategory's description for courseLecturer
    const selectedSubCategory = this.problemSubCategoryList.find(item => item.id === this.ticketForm.value.subCategoryID);
    const courseLecturerValue = selectedSubCategory
      ? (this.lang == 'en' ? selectedSubCategory.subCategoryDescrEng : selectedSubCategory.subCategoryDescrChi)
      : (this.ticketForm.value.courseLecturer || "");

    let param: any = {
      "id": this.ticketForm.value.id,
      "detail": this.ticketForm.value.detail,
      "ticketStatusID": this.ticketForm.value.ticketStatusID || null,
      "assignedToTeamID": null,
      "resolutionTypeID": this.ticketForm.value.resolutionTypeID || null,
      "resolutionComments": this.ticketForm.value.resolutionComments || "",
      "severityLevel": this.ticketForm.value.severityLevel || null,
      "subCategoryID": this.ticketForm.value.subCategoryID,
      "clientInfo": "",
      "contactNo": this.ticketForm.value.contactNo + "",
      "courseLecturer": courseLecturerValue,
      "emailCC": this.ticketForm.value.emailCC,
      "attachmentIsModified": false
    }
    console.log('Complete param object:', JSON.stringify(param, null, 2));
    if (this.ticketForm.value.id != 0 && this.rowVersion) {
      param.rowVersion = this.rowVersion
    }
    this.ticketNo = "";
    //判断是否删除或添加file
    let addFile: any = {};
    //是否有新增文件
    addFile = this.fileList.find((file) => {
      return !file.id
    })
    if (this.ticketId) {
      this.isSaveTicket = true;
      if (this.originalFileList.length != this.fileList.length || this.originalFileList.toString() != this.fileList.toString() || addFile) {
        //是否删除或添加字段为true
        param.attachmentIsModified = true;
      }
    }
    try {
      console.log('✅ [Ticket Component] About to call saveTicketInfo()');
      console.log('Sending to backend:', JSON.stringify(param, null, 2));
      let res: any = await firstValueFrom(
        this.ticketService.saveTicketInfo(param)
      );
      console.log('✅ [Ticket Component] saveTicketInfo() call completed successfully');
      this.isOperateAction = true;
      this.isChangeProblemSubCategory = false;
      this.isLoading = false
      this.isSubmitVisible = true;
      this.ticketId = res.id;
      this.ticketGuid = res.guid;
      this.ticketNo = res.ticketNo;

      // Emit event when a new ticket is successfully submitted
      if (this.ticketStatusID === 0) {
        console.log('📝 [Ticket Component] New ticket submitted, emitting ticketSubmitted event');
        this.ticketSubmitted.emit();
      }

      // Call InsertTicketRemark after ticket submission if remark exists
      // ✅ Collect all remarks to save: current form value + pending remarks
      const remarksToSave: string[] = [];

      // Add current form remark if exists
      if (initialRemarkValue) {
        remarksToSave.push(initialRemarkValue);
      }

      // Add all pending remarks
      if (this.pendingRemarks.length > 0) {
        remarksToSave.push(...this.pendingRemarks);
      }

      // Save all remarks
      if (remarksToSave.length > 0 && this.ticketId) {
        console.log(`📝 [Ticket Component] Saving ${remarksToSave.length} remarks for ticket ${this.ticketId}`);

        for (let i = 0; i < remarksToSave.length; i++) {
          const remark = remarksToSave[i];
          try {
            let remarkParam = {
              ticketId: this.ticketId,
              remark: remark
            };
            await firstValueFrom(this.ticketService.addRemark(remarkParam));
            console.log(`✅ [Ticket Component] Saved remark ${i + 1}/${remarksToSave.length}`);
          } catch (remarkError: any) {
            console.error(`❌ [Ticket Component] Error saving remark ${i + 1}:`, remarkError);
            this.message.error(`Failed to add remark ${i + 1}: ${remarkError?.message || 'Unknown error'}`);
          }
        }

        // Clear all remark storage after successful save
        this.remarkForm.get('remark')?.setValue('');
        this.pendingRemarks = [];
        this.message.success(`${remarksToSave.length} remark(s) saved successfully`);
      }

      // Load ticket data
      this.getTicketById();

      // Refresh remarks list after ticket data is loaded
      if (this.ticketId) {
        this.showRemark();
      }

      //删除文件
      if (this.delFileList.length > 0) {
        this.delFileList.forEach((id) => {
          this.ticketService.deleteFilesByID(id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => { },
              error: (error) => {
                console.error('Error deleting file by ID: ', error);
              }
            })
        })
      }
      //如果修改了问题类型就判断
      if (this.ticketStatusID != 0 && this.originalSubCategoryID != this.ticketForm.value.subCategoryID) {
        this.changeProblemCategory(1)
      }
      //调用文件导入接口
      const formData = new FormData();

      if (this.fileList.length > 0) {
        this.fileList.forEach((file) => {
          if (!file.id) formData.append('files', file);
        })
        if (addFile) {
          await firstValueFrom(
            this.ticketService.importAttachment(res.id, formData)
          );
        }
      }

    }
    catch (error: any) {
      if (error?.error?.code == 409) {
        this.isHaveSupportTeamOperate = true;
      }
      this.isLoading = false
    }
  }
  //重置列表信息 用于创建新的ticket
  resetForm(e: MouseEvent): void {
    e.preventDefault();
    this.ticketForm.reset();
  }
  //取消列表-如果有id就取消ticekt，没有id就关闭
  cancelForm(): void {
    if (this.ticketForm.get('ticketNo')?.value) {
      this.isCancelVisible = true;
    } else {
      this.back(true)
    }
  }
  //返回到ticket-用于弹框
  backToTicket() {
    this.isCancelVisible = false;
    this.isReassignTeam = false;
    this.isShowAccept = false;
    this.isClosedVisible = false;
    this.isBackConfirm = false;
    this.isShowChangeSubCategoryReassignLog = false;
    this.isShowAcceptSubCategory = false;
  }
  backToTicketOperate() {
    this.isHaveSupportTeamOperate = false;
    this.getTicketById();
  }

  /*
  *弹框方法-start
  *********************************************************************************************************
  */
  handleOk(): void {
    this.isSubmitVisible = false;
    this.ticketStatusID = 1;
    this.closeTicket();
  }
  handleBack(): void {
    this.isSubmitVisible = false;
    this.ticketStatusID = (this.ticketStatusID == this.ticketStatusEnum['inProgress'] || this.ticketStatusID == this.ticketStatusEnum['reassign']) ? this.ticketStatusID : 1;
    // Get subcategory name and ensure it's displayed
    const findSubCategory = this.problemSubCategoryList.find((item) => {
      return item.id == this.ticketForm.value.subCategoryID
    })
    if (findSubCategory) {
      this.ticketForm.get('subCategoryName')?.setValue(this.lang == "en" ? findSubCategory.subCategoryDescrEng : findSubCategory.subCategoryDescrChi);
    } else {
      this.ticketForm.get('subCategoryName')?.setValue('');
    }
    //显示文件
    this.isFileChange = false;
    this.getFilesById();
  }
  handleCancelBack(): void {
    this.isCancelVisible = false;
  }

  closeTicket(): void {
    this.backToTicket();
    this.back(true);
  }
  async handleCancelOk() {
    this.isButtonLoading = true;
    try {
      let param = {
        ticketStatusID: 5,
        ticketStatus: "Canceled",
        supportTeamID: 0,
        rowVersion: this.rowVersion || ""
      }
      await firstValueFrom(
        this.ticketService.updateTicketStatus(this.ticketId, param)
      );
      this.isButtonLoading = false;
      this.isClosed = true;
      this.isOperateAction = true;
      // ✅ Refresh ticket data after canceling
      this.getTicketById();
    } catch (error) {
      this.isButtonLoading = false;
      this.isCancelVisible = false;
      this.isHaveSupportTeamOperate = true;
    }
  }

  openNewTicket(): void {
    this.isClosed = false;
    this.isCancelVisible = false;
    this.ticketStatusID = 0;
    this.fileList = [];
    this.fileName = "";
    this.initTicketInfo();
  }
  /*
  *弹框方法-end
  *********************************************************************************************************
  */

  /*
  *文件处理方法-start
  *********************************************************************************************************
  */
  //选择文件
  import(e: any): void {
    for (let val of e.target.files) {
      val.originalFileName = val.name;
      val.fileMimeType = val.type;
      this.fileName = val.name + ";" + this.fileName;
      this.isFileChange = true;
      var reader = new FileReader();
      reader.readAsDataURL(val);
      reader.onload = (e: any) => {
        val.showImage = e.target.result
        this.fileList.push(val);
      }
    }
  }
  //获取文件
  getFileById(id: number) {
    this.ticketService.downloadFilesByID(id, true)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          var reader = new FileReader();
          reader.readAsDataURL(data);
          reader.onload = (e: any) => {
            const findCategory = this.fileList.find((file) => {
              return file.id == id;
            })
            findCategory.showImage = e.target.result;
          }
        },
        error: (error) => {
          console.error('Error downloading the file. error: ' + error);
        }
      })
  }
  //下载文件
  downloadFile(id: number, fileName: string): void {
    console.log('📥 [Download] Starting download for file ID:', id, 'FileName:', fileName);

    // First try to find the file in fileList to get the uri
    const file = this.fileList.find(f => f.id === id);

    if (file && file.uri) {
      // If we have the uri from backend, use it directly for download
      console.log('📥 [Download] Using direct URI:', file.uri);
      // Create a temporary anchor element to trigger download
      const link = document.createElement('a');
      link.href = file.uri;
      link.download = fileName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log('✅ [Download] Download triggered via direct URI');
    } else {
      // Fallback to API call if uri is not available
      console.log('📥 [Download] URI not available, using API call');
      this.ticketService.downloadFilesByID(id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
        next: (data) => {
          console.log('📥 [Download] Blob received:', data);
          console.log('📥 [Download] Blob type:', data.type);
          console.log('📥 [Download] Blob size:', data.size);

          if (data && data.size > 0) {
            saveAs(data, fileName);
            console.log('✅ [Download] File saved successfully');
          } else {
            console.error('❌ [Download] Blob is empty or invalid');
          }
        },
        error: (error) => {
          console.error('❌ [Download] Error downloading the file:', error);
        }
      })
    }
  }
  //删除文件
  deleteFiles(file?: any): void {
    if (file.id) {
      let fileIndex = this.fileList.findIndex((item) => {
        return file.id == item.id;
      })
      this.fileList.splice(fileIndex, 1);
      this.delFileList.push(file.id);
    } else {
      let fileIndex = this.fileList.findIndex((item) => {
        return file.name == item.name;
      })
      this.fileList.splice(fileIndex, 1);
    }
    this.isFileChange = true;
    this.showFileName();

  }
  /*
  *文件处理方法-end
  *********************************************************************************************************
  */

  //support-接受ticket
  async acceptForm(isClose?: boolean) {
    this.isOperateAction = true;
    this.isLoading = true;
    try {
      if (!isClose) {
        //如果操作者选择新的SubCategory则提示他一下
        if (this.changeProblemSubCategoryAndAcceptOrClose()) {
          return;
        }
        this.ticketForm.get('ticketStatusID')?.setValue(2)
        if (this.saveFromDirty()) {
          await this.saveAcceptForm();
        }

        // Call acceptTicket API with ticketID and current user email
        await firstValueFrom(
          this.apiAdapter.acceptTicket(this.ticketId, this.userInfo.userPrincipalName || this.userInfo.mail || '')
        );

        let param = {
          ticketStatusID: 2,
          ticketStatus: "Accepted",
          supportTeamID: 0,
          rowVersion: this.rowVersion || ""
        }
        await firstValueFrom(
          this.ticketService.updateTicketStatus(this.ticketId, param)
        );
        this.isShowAccept = true;
        this.isLoading = false;
        // Emit event when ticket is successfully accepted
        console.log('📝 [Ticket Component] Ticket accepted, emitting ticketAccepted event');
        this.ticketAccepted.emit();
        this.getTicketById();
      } else {
        let param = {
          ticketStatusID: 2,
          ticketStatus: "Accepted",
          supportTeamID: 0,
          rowVersion: this.rowVersion || ""
        }
        let res = await firstValueFrom(
          this.ticketService.updateTicketStatus(this.ticketId, param)
        );
        this.rowVersion = res.data?.rowVersion
      }
    } catch (error) {
      this.isHaveSupportTeamOperate = true;
      this.isLoading = false;
    }
  }
  async acceptFormChangeSubCategory() {
    this.isButtonLoading = true
    this.isOperateAction = true;
    let param = {
      ticketStatusID: 2,
      ticketStatus: "Accepted",
      supportTeamID: 0,
      rowVersion: this.rowVersion || ""
    }
    this.isLoading = true;
    try {
      this.ticketForm.get('ticketStatusID')?.setValue(2)
      if (this.saveFromDirty()) {
        await this.saveAcceptForm();
      }

      // Call acceptTicket API with ticketID and current user email
      await firstValueFrom(
        this.apiAdapter.acceptTicket(this.ticketId, this.userInfo.userPrincipalName || this.userInfo.mail || '')
      );

      this.isButtonLoading = false;
      this.isShowAcceptSubCategory = false;
      await firstValueFrom(
        this.ticketService.updateTicketStatus(this.ticketId, param)
      );
      // Emit event when ticket is successfully accepted
      console.log('📝 [Ticket Component] Ticket accepted (subCategory changed), emitting ticketAccepted event');
      this.ticketAccepted.emit();
      await this.getTicketById();
      this.isShowAccept = true;
      this.isLoading = false;
    } catch (error) {
      this.isHaveSupportTeamOperate = true;
      this.isLoading = false;
    }
  }
  changeProblemSubCategoryAndAcceptOrClose() {
    if (this.isChangeProblemSubCategory && this.originalticketForm && this.originalticketForm.subCategoryID != this.ticketForm.value.subCategoryID && !this.isShowAcceptSubCategory) {
      this.isShowAcceptSubCategory = true;
      return true
    }
    return false
  }

  //support-重新分配ticket
  async reassignTeam() {
    if (this.isChangeProblemSubCategory && this.ticketStatusID != 0 && this.originalticketForm && this.originalticketForm.subCategoryID != this.ticketForm.value.subCategoryID) {
      this.isShowChangeSubCategoryReassignLog = true;
      return;
    }
    this.ticketService.getSupportTeam(this.assignedToTeamIDParam)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.assignedToTeamList = res.data;
          this.isReassignTeam = true;

          // Show warning if using fallback data
          if (res.isFallback) {
            console.warn('⚠️ Using fallback team data due to authentication issues');
          // You could show a user notification here if needed
          // Example: this.message.warning('Using fallback teams - some features may be limited');
        }
      },
      error: (error) => {
        console.error('Error getting support team: ', error);
        // Show user-friendly error message
        console.error('Unable to load support teams. Please try again or contact support.');
      }
    })
  }
  
  //确认重新分配
  async confirmReassign() {
    if (this.assignedToTeamID === 0) {
      this.message.warning('Please select a team');
      return;
    }

    this.isButtonLoading = true;
    try {
      let param = {
        ticketStatusID: 4, // Reassigned status
        ticketStatus: "Assigned",
        supportTeamID: this.assignedToTeamID,
        rowVersion: this.rowVersion || ""
      };

      await firstValueFrom(
        this.ticketService.updateTicketStatus(this.ticketId, param)
      );

      // Find the selected team name
      const selectedTeam = this.assignedToTeamList.find(team => team.id === this.assignedToTeamID);
      this.assignedToTeamName = selectedTeam ? selectedTeam.name : '';

      this.message.success('Ticket reassigned successfully');
      this.isReassignTeam = false; // Hide the team selection
      this.assignedToTeamID = 0; // Reset selection

      // Refresh ticket data
      await this.getTicketById();

    } catch (error) {
      console.error('Error reassigning ticket: ', error);
      this.message.error('Failed to reassign ticket');
    } finally {
      this.isButtonLoading = false;
    }
  }

  //取消重新分配
  cancelReassign() {
    this.isReassignTeam = false;
    this.assignedToTeamID = 0;
    this.assignedToTeamList = [];
  }

  //分配接口
  async reassign() {
    this.isOperateAction = true;
    if (this.assignedToTeamID == 0 && !this.isChangeProblemSubCategory) {
      return;
    }
    let param = {
      ticketStatusID: 4,
      ticketStatus: "Assigned",
      supportTeamID: this.assignedToTeamID || 0,
      rowVersion: ""
    }
    this.isButtonLoading = true;
    try {
      await this.saveAcceptForm(param.ticketStatusID);
      if (this.rowVersion) {
        param.rowVersion = this.rowVersion;
      }
      if (this.isChangeProblemSubCategory) {
        let res = await firstValueFrom(
          this.ticketService.getReassignTeamName(Number(this.ticketForm.value.subCategoryID))
        );
        this.assignedToTeamNameChangeSubCategory = res.name;
        param.supportTeamID = res.id;
      }
      await firstValueFrom(
        this.ticketService.updateTicketStatus(this.ticketId, param)
      );
      this.ticketForm.get('assignedToTeamID')?.setValue(this.assignedToTeamID)
      this.isButtonLoading = false;
      this.isReassignTicket = true
      let find = this.assignedToTeamList.find((team) => {
        return team.id == this.assignedToTeamID
      })
      this.assignedToTeamName = find ? find.name : '';
    } catch (error) {
      this.isReassignTeam = false;
      this.isHaveSupportTeamOperate = true;
      this.isButtonLoading = false;
    }
  }
  getReassignTeamName(id: number) {
    this.ticketService.getReassignTeamName(id)
  }

  async changeSubCategoryReassignOK() {
    await this.reassign();
    this.isShowReassignTicket = true;
  }

  //显示日志
  showLogs(): void {
    let param = {
      "page": 0,
      "pageSize": 100,
      "keyword": "",
      "id": this.ticketId,
      "isDescrSubmittedDate": true,
      "skipUntil": "",
      "skipIds": [],
    }
    this.ticketService.getTicketLogsList(param)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.logListOfData = res.data;
          this.isShowLog = true;
        },
        error: (error) => {
          console.error('Error getting ticket logs: ', error);
        }
      })
  }
  //显示评论
  showRemark(): void {
    let param = {
      "page": 0,
      "pageSize": 100,
      "keyword": "",
      "ticketId": this.ticketId,
      "isDescrSubmittedDate": true,
      "skipUntil": "",
      "skipIds": [],
    }
    this.ticketService.getTicketRemark(param)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.remarkList = res.data;
        },
        error: (error) => {
          console.error('Error getting ticket remarks: ', error);
        }
      })
  }
  //关闭日志
  closeLog(): void {
    this.isShowLog = false;
  }
  //support-接受日志后填写信息保存
  async saveAcceptForm(ticketStatusID?: number) {
    this.isLoading = true;
    this.isOperateAction = true;

    // Get the selected subcategory's description for courseLecturer
    const selectedSubCategory = this.problemSubCategoryList.find(item => item.id === this.ticketForm.value.subCategoryID);
    const courseLecturerValue = selectedSubCategory
      ? (this.lang == 'en' ? selectedSubCategory.subCategoryDescrEng : selectedSubCategory.subCategoryDescrChi)
      : (this.ticketForm.value.courseLecturer ?? "");

    let param = {
      "detail": this.ticketForm.value.detail,
      "ticketStatusID": this.ticketForm.value.ticketStatusID,
      "assignedToTeamID": this.ticketForm.value.assignedToTeamID,
      "subCategoryID": this.ticketForm.value.subCategoryID,
      "clientInfo": "",
      "contactNo": this.ticketForm.value.contactNo + "",
      "emailCC": this.ticketForm.value.emailCC,
      "id": this.ticketForm.value.id,
      "resolutionTypeID": this.ticketForm.value.resolutionTypeID,
      "actualTimeSpent": this.ticketForm.value.actualTimeSpent,
      "courseLecturer": courseLecturerValue,
      "resolutionComments": this.ticketForm.value.resolutionComments,
      "severityLevel": this.ticketForm.value.severityLevel,
      "rowVersion": this.rowVersion || ""
    }
    try {
      if (!this.saveFromDirty()) {
        this.isLoading = false;
        return;
      }
      let res: any = await firstValueFrom(
        this.ticketService.saveTicketInfo(param)
      );
      this.rowVersion = res.rowVersion;
      this.assignedToTeamID = res.assignedToTeamID
      //如果修改了问题类型就判断
      // if (this.originalSubCategoryID != this.ticketForm.value.subCategoryID && ticketStatusID) {
      //   this.changeProblemCategory(ticketStatusID || 2)
      // }

      this.originalticketForm = JSON.parse(JSON.stringify(this.ticketForm.value));
      this.isLoading = false;
    } catch (error) {
      this.isHaveSupportTeamOperate = true;
      this.isLoading = false;
    }
  }
  //关闭ticket
  closeTicketForm() {
    this.isClosedVisible = true;
  }
  //关闭接口
  async handleClosedOk() {
    this.isOperateAction = true;
    this.isButtonLoading = true;
    try {
      if (this.ticketStatusID == this.ticketStatusEnum['submitted'] || this.ticketStatusID == this.ticketStatusEnum['reassign']) {
        await this.saveAcceptForm();
        await this.acceptForm(true);
      } else if (this.ticketStatusID == this.ticketStatusEnum['inProgress']) {
        await this.saveAcceptForm();
      }
      let param = {
        ticketStatusID: 3,
        ticketStatus: "Closed",
        supportTeamID: 0,
        rowVersion: this.rowVersion || ""
      }
      await firstValueFrom(
        this.ticketService.updateTicketStatus(this.ticketId, param)
      );
      this.isButtonLoading = false;
      this.isClosedTicket = true;
      // Emit event when ticket is successfully closed
      console.log('📝 [Ticket Component] Ticket closed, emitting ticketClosed event');
      this.ticketClosed.emit();
      // ✅ Refresh ticket data after closing
      this.getTicketById();
    } catch (error) {
      this.isHaveSupportTeamOperate = true;
      this.isButtonLoading = false;

    }
  }
  /**
   *  cctoEmail方法处理-start
   *  *********************************************************************************************************
   */
  blurFunction(): void {
    this.isClickEmail = false;
  }
  clickFunction(): void {
    this.isClickEmail = true;
    this.isMousemoveEmail = false;
  }
  mousemoveFunction(): void {
    this.isMousemoveEmail = true;
  }
  mouseleaveFunction(): void {
    this.isClickEmail = false;
    this.isMousemoveEmail = false
  }
  /**
   *  cctoEmail方法处理-end
   *  *********************************************************************************************************
   */

  //显示pdf
  showPdfInfo(uri: string, id: number, pdfName: string): void {
    this.isShowPdf = true;
    this.pdfSrc = uri;
    this.pdfId = id;
    this.pdfName = pdfName;
  }

  changeProblemCategory(type?: number): void {
    let param = {
      "ticketStatusID": type,
      "ticketStatus": "ChangeCategory",
      "supportTeamID": 0
    }
    this.ticketService.updateTicketStatus(this.ticketId, param)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => { },
        error: (error) => {
          console.error('Error updating ticket status: ', error);
        }
      })
  }

  getStatus(id: number) {
    let status: any = {
      1: 'Submitted',
      2: this.isSupport ? 'In Progress (Accepted)' : 'In Progress',
      3: 'Closed',
      4: this.isSupport ? 'In Progress (Reassigned)' : 'In Progress',
      5: 'Canceled'
    }
    return status[id]
  }

  getCategoryName() {
    const categoryName = this.ticketForm.get('categoryName')?.value || '';
    return categoryName || '-';
  }

  saveFromDirty() {
    // Check if originalticketForm is initialized
    if (!this.originalticketForm) {
      return false; // No changes if form hasn't been initialized yet
    }

    if (!this.isSupport) {
      if ((this.originalticketForm.contactNo || '') != (this.ticketForm.value.contactNo || '') || (this.originalticketForm.emailCC?.toString() || '') != (this.ticketForm.value.emailCC?.toString() || '') || (this.originalticketForm.detail || '') != (this.ticketForm.value.detail || '')) {
        return true;
      }
      return false;
    } else {
      if ((this.originalticketForm.subCategoryID || 0) != (this.ticketForm.value.subCategoryID || 0) || (this.originalticketForm.resolutionTypeID || 0) != (this.ticketForm.value.resolutionTypeID || 0) || (this.originalticketForm.severityLevel || 0) != (this.ticketForm.value.severityLevel || 0) || (this.originalticketForm.resolutionComments || '') != (this.ticketForm.value.resolutionComments || '') || (this.originalticketForm.actualTimeSpent || '') != (this.ticketForm.value.actualTimeSpent || '')) {
        return true;
      }
      return false;
    }
  }


  changeProblemSubCategory() {
    this.isChangeProblemSubCategory = true;
  }


  copyLink() {
    let url = window.location.origin + '/#/inquiry?ticketId=' + this.ticketGuid;
    const dataContainer = document.createElement('input');
    dataContainer.value = url;
    document.body.appendChild(dataContainer);
    // 选中并复制文本到剪切板
    dataContainer.select();
    document.execCommand('copy');
    // 移除input元素
    document.body.removeChild(dataContainer);
    this.message.success("URL copied")
  }

  addRemark() {
    const remarkText = this.remarkForm.value.remark;
    if (!remarkText?.trim()) {
      return;
    }

    // ✅ For new tickets (no ticketId), store remark in pending list
    if (!this.ticketId || this.ticketId === 0) {
      this.pendingRemarks.push(remarkText);

      // Show in UI immediately
      this.remarkList.push({
        userAD: this.userInfo.displayName,
        createdDate: new Date().toString(),
        remark: remarkText
      });

      // Clear the form
      this.remarkForm.get('remark')?.setValue("");
      return;
    }

    // ✅ For existing tickets, save to backend immediately
    let param = {
      ticketId: this.ticketId,
      remark: remarkText
    }

    this.ticketService.addRemark(param)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          // Clear the form only after successful save
          this.remarkForm.get('remark')?.setValue("");
          // ✅ Refresh remarks list to show the newly added remark
          this.showRemark();
        },
        error: (error) => {
          console.error('Error adding remark: ', error);
          // Don't clear form on error - user can retry
        }
      })
  }

  // VDI Integration Methods
  // Cache the VDI ticket check to avoid repeated calculations
  private _isVDITicket: boolean | null = null;

  isVDICreateVmTicket(): boolean {
    // Check if this is a VDI ticket that requires VM creation
    // This combines the VDI ticket check with the "Create VM" requirement
    return this.isVDITicket();
  }

  isVDITicket(): boolean {
    // Return cached result if available
    if (this._isVDITicket !== null) {
      return this._isVDITicket;
    }

    const normalise = (value: any): string => {
      if (value === null || value === undefined) {
        return '';
      }
      return String(value).toUpperCase();
    };

    const includesVDIKeyword = (value: string): boolean => {
      if (!value) {
        return false;
      }
      const keywords = ['VDI', 'VIRTUAL DESKTOP', 'AZURE VIRTUAL DESKTOP', 'AVD'];
      return keywords.some(keyword => value.includes(keyword));
    };

    const ticket = this.ticketInfo?.ticket || {};

    const categoryIdFromTicketRaw = ticket.categoryID ?? ticket.categoryId ?? ticket.category?.id ?? ticket.subCategory?.categoryID ?? ticket.subCategory?.categoryId ?? ticket.subCategory?.category?.id;
    const categoryIdFromTicket = categoryIdFromTicketRaw !== undefined && categoryIdFromTicketRaw !== null
      ? Number(categoryIdFromTicketRaw)
      : undefined;

    const formSubCategoryId = this.ticketForm.get('subCategoryID')?.value;
    const rawSubCategoryId = formSubCategoryId ?? ticket.subCategoryID;
    const subCategoryID = rawSubCategoryId !== undefined && rawSubCategoryId !== null
      ? Number(rawSubCategoryId)
      : undefined;
    const selectedSubCategory = this.problemSubCategoryList.find(item => item.id === subCategoryID);

    const formCategoryId = this.ticketForm.get('categoryID')?.value;
    const selectedSubCategoryCategoryId = selectedSubCategory?.categoryId ?? (selectedSubCategory as any)?.categoryID;
    const rawCategoryId = categoryIdFromTicket ?? selectedSubCategoryCategoryId ?? formCategoryId;
    const effectiveCategoryId = rawCategoryId !== undefined && rawCategoryId !== null
      ? Number(rawCategoryId)
      : undefined;

    const categoryFromTicket = normalise(
      ticket.category?.categoryCode ||
      ticket.category?.categoryDescrEng ||
      ticket.subCategory?.category?.categoryCode ||
      ticket.subCategory?.category?.categoryDescrEng
    );
    const categoryFromList = normalise(
      this.problemCategoryList.find(cat => cat.id === effectiveCategoryId)?.categoryCode ||
      this.problemCategoryList.find(cat => cat.id === effectiveCategoryId)?.categoryDescrEng
    );
    const categoryCode = normalise(this.categoryCode) || categoryFromTicket || categoryFromList;

    const subCategory = ticket.subCategory || selectedSubCategory || {};
    const subCategoryCode = normalise(subCategory.subCategoryCode || this.subCategoryCode);
    const subCategoryName = normalise(subCategory.subCategoryDescrEng || subCategory.subCategoryDescrChi);

    const detail = normalise(this.ticketForm.get('detail')?.value || ticket.detail);
    const serviceDescription = normalise(ticket.serviceDescription || ticket.serviceTitle);

    const knownIdMapping = effectiveCategoryId === 1 && subCategoryID !== undefined && [1, 2].includes(subCategoryID);
    const matchesCategoryId = effectiveCategoryId === 27
    const matchesCategory = includesVDIKeyword(categoryCode) || includesVDIKeyword(categoryFromList);
    const matchesSubCategory = includesVDIKeyword(subCategoryCode) || includesVDIKeyword(subCategoryName);
    const matchesDetail = includesVDIKeyword(detail) || includesVDIKeyword(serviceDescription);

    const isVDI = Boolean(matchesCategoryId);

    this._isVDITicket = isVDI;

    console.log('🔍 [Ticket] isVDITicket check:', {
      categoryIdFromTicket,
      categoryID: effectiveCategoryId,
      categoryCode,
      subCategoryID,
      subCategoryCode,
      subCategoryName,
      hasVDIDetail: matchesDetail,
      isVDI,
      ticketId: this.ticketId,
      ticketNo: this.ticketNo,
      cached: false
    });

    return isVDI;
  }

  // Call this method to reset the cache when ticket data changes
  private resetVDITicketCache(): void {
    this._isVDITicket = null;
  }

  private loadVmDetails(source: 'ngOnInit' | 'getTicketInfoByInfo' | 'createVm' | 'refreshTicketData' | 'approveVdiTicket' | 'unknown' = 'unknown'): void {
    // #region agent log (debug-session)
    fetch('https://localhost:7182/ingest/67a97cca-a992-499c-a645-9a0d2ff80c1a',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ticket.component.ts:loadVmDetails(entry)',message:'loadVmDetails called',data:{source,ticketId:this.ticketId,hasTicketId:!!this.ticketId,isVDITicket:this.isVDITicket(),categoryID:this.ticketForm?.get('categoryID')?.value ?? null,subCategoryID:this.ticketForm?.get('subCategoryID')?.value ?? null},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
    // #endregion
    if (!this.ticketId) {
      this.vmDetails = null;
      this.vmDetailsError = null;
      this.vmDetailEntries = [];
      this.isVmCreated = false;
      // #region agent log (debug-session)
      fetch('https://localhost:7182/ingest/67a97cca-a992-499c-a645-9a0d2ff80c1a',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ticket.component.ts:loadVmDetails(noTicketId)',message:'loadVmDetails skipped (missing ticketId)',data:{source},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
      // #endregion
      return;
    }

    this.isVmDetailsLoading = true;
    this.vmDetailsError = null;

    // #region agent log (debug-session)
    fetch('https://localhost:7182/ingest/67a97cca-a992-499c-a645-9a0d2ff80c1a',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ticket.component.ts:loadVmDetails(beforeGetVmDetails)',message:'Calling vdiService.getVmDetails',data:{source,ticketId:this.ticketId,isVDITicket:this.isVDITicket()},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'B'})}).catch(()=>{});
    // #endregion
    this.vdiService.getVmDetails(this.ticketId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (details: any) => {
          const parsed = this.parseVmDetails(details);
          this.vmDetails = parsed.payload;
          this.vmDetailEntries = this.buildVmDetailEntries(parsed.payload);
          const hasDetails = this.vmDetailEntries.length > 0;
          if (parsed.success !== null) {
            this.isVmCreated = parsed.success;
          } else {
            this.isVmCreated = hasDetails;
          }
          this.isVmDetailsLoading = false;
          console.log("🖥️ [Ticket Component] VM Details loaded:", this.isVmCreated);
        // #region agent log (debug-session)
        fetch('https://localhost:7182/ingest/67a97cca-a992-499c-a645-9a0d2ff80c1a',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ticket.component.ts:loadVmDetails(next)',message:'VM details loaded',data:{source,ticketId:this.ticketId,parsedSuccess:parsed.success,entryCount:this.vmDetailEntries.length,isVmCreated:this.isVmCreated},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
        // #endregion
      },
      error: (error: any) => {
        console.error('Error fetching VM details:', error);
        this.vmDetailsError = error?.message || 'Failed to load VM details';
        if (!this.hasVmDetails()) {
          this.vmDetails = null;
          this.vmDetailEntries = [];
        }
        this.isVmDetailsLoading = false;
        // #region agent log (debug-session)
        fetch('https://localhost:7182/ingest/67a97cca-a992-499c-a645-9a0d2ff80c1a',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ticket.component.ts:loadVmDetails(error)',message:'VM details load failed',data:{source,ticketId:this.ticketId,errorMessage:error?.message ?? 'unknown'},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
        // #endregion
      }
    });
  }

  // Poll for VM creation status after approval
  // This handles the case where VM creation takes time and we need to wait for it
  private pollForVmCreation(): void {
    if (!this.ticketId || !this.isVDITicket()) {
      return;
    }

    console.log('🔄 [Ticket] Starting to poll for VM creation...');
    let pollCount = 0;
    const maxPolls = 15; // Poll for up to 30 seconds (15 * 2 seconds)
    const pollInterval = 2000; // Check every 2 seconds

    const pollTimer = setInterval(() => {
      pollCount++;
      console.log(`🔄 [Ticket] Polling for VM creation... (${pollCount}/${maxPolls})`);

      this.vdiService.getVmDetails(this.ticketId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (details: any) => {
            const parsed = this.parseVmDetails(details);
            this.vmDetails = parsed.payload;
            this.vmDetailEntries = this.buildVmDetailEntries(parsed.payload);
            const hasDetails = this.vmDetailEntries.length > 0;

            // Update isVmCreated based on response
            if (parsed.success !== null) {
              this.isVmCreated = parsed.success;
            } else {
              this.isVmCreated = hasDetails;
            }

            console.log(`🖥️ [Ticket] Poll result: isVmCreated = ${this.isVmCreated}`);

            // Reset cache and trigger UI update
            this.resetCreateVmButtonCache();
            this.cdr.detectChanges();

            // If VM is created, stop polling
            if (this.isVmCreated) {
              console.log('✅ [Ticket] VM created! Stopping poll.');
              clearInterval(pollTimer);
              this.message.success('VM has been created successfully!');
            } else if (pollCount >= maxPolls) {
              console.log('⏰ [Ticket] Max polling attempts reached. Stopping poll.');
              clearInterval(pollTimer);
              this.message.info('VM creation is in progress. Please refresh the page later.');
            }
          },
          error: (error: any) => {
            console.error('❌ [Ticket] Error polling for VM creation:', error);
            if (pollCount >= maxPolls) {
              clearInterval(pollTimer);
            }
          }
        });
    }, pollInterval);

    // Store the timer ID for cleanup (optional, if needed later)
    // this.vmCreationPollTimer = pollTimer;
  }

  hasVmDetails(): boolean {
    return this.vmDetailEntries.length > 0;
  }

  isVmApproved(): boolean {
    return (this.approvalStatus || '').trim().toLowerCase() === 'approved';
  }

  // Cache for canShowCreateVmButton result
  private _canShowCreateVmButton: boolean | null = null;

  canShowCreateVmButton(): boolean {
    // Return cached result if available
    if (this._canShowCreateVmButton !== null) {
      return this._canShowCreateVmButton;
    }

    const hasTicket = Number(this.ticketId) > 0;
    const result = hasTicket && this.isVDITicket() && this.isVmApproved() && !this.isVmCreated;

    console.log('🔍 [Ticket] Create VM button conditions check:', {
      ticketId: this.ticketId,
      hasTicket: hasTicket ? 'YES' : 'NO',
      isVDITicket: this.isVDITicket() ? 'YES' : 'NO',
      isVmApproved: this.isVmApproved() ? 'YES' : 'NO',
      isVmCreated: this.isVmCreated ? 'YES' : 'NO',
      result: result ? 'SHOW_BUTTON' : 'HIDE_BUTTON'
    });

    this._canShowCreateVmButton = result;
    return result;
  }

  // Reset the create VM button cache when ticket data changes
  private resetCreateVmButtonCache(): void {
    this._canShowCreateVmButton = null;
  }

  trackVmDetail(index: number, item: VmDetailEntry): string {
    return `${item.key}-${index}`;
  }

  private parseVmDetails(response: any): { success: boolean | null; payload: any } {
    if (response === null || response === undefined) {
      return { success: null, payload: null };
    }

    const hasSuccessProp = response?.success !== undefined || response?.data?.success !== undefined;
    const successFlag = hasSuccessProp ? this.toBoolean(response?.success ?? response?.data?.success) : null;

    if (response?.data !== undefined && response?.data !== null) {
      return { success: successFlag, payload: response.data };
    }

    if (response?.vmDetails !== undefined) {
      return { success: successFlag, payload: response.vmDetails };
    }

    if (typeof response === 'object') {
      const { success, ...rest } = response;
      if (Object.keys(rest).length === 1 && rest.data !== undefined) {
        return { success: successFlag, payload: rest.data };
      }
      return { success: successFlag, payload: rest };
    }

    return { success: successFlag, payload: response };
  }

  private toBoolean(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'string') {
      return value.trim().toLowerCase() === 'true';
    }
    return !!value;
  }

  private buildVmDetailEntries(details: any): VmDetailEntry[] {
    if (details === null || details === undefined) {
      return [];
    }

    if (Array.isArray(details)) {
      if (!details.length) {
        return [];
      }
      return details.map((value, index) => this.createVmDetailEntry(String(index), value));
    }

    if (typeof details === 'object') {
      const keys = Object.keys(details);
      if (!keys.length) {
        return [];
      }
      return keys.map((key) => this.createVmDetailEntry(key, details[key]));
    }

    return [this.createVmDetailEntry('value', details)];
  }

  private createVmDetailEntry(key: string, value: any): VmDetailEntry {
    const isStructured = this.isStructuredVmDetail(value);
    const display = this.stringifyVmDetailValue(value);
    return { key, value, display, isStructured };
  }

  private isStructuredVmDetail(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (Array.isArray(value)) {
      return value.some((item) => typeof item === 'object');
    }
    return typeof value === 'object';
  }

  private stringifyVmDetailValue(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    if (Array.isArray(value)) {
      if (!value.length) {
        return '-';
      }
      if (value.every((item) => item === null || item === undefined || typeof item !== 'object')) {
        return value.map((item) => (item === null || item === undefined ? '-' : String(item))).join(', ');
      }
      return JSON.stringify(value, null, 2);
    }

    if (value instanceof Date) {
      return value.toISOString();
    }

    if (typeof value === 'object') {
      return JSON.stringify(value, null, 2);
    }

    return String(value);
  }

  /**
   * Handle VM creation completion event from VDI approval status component
   */
  onVmCreationCompleted(event: { ticketId: number; vmName: string; success: boolean }): void {
    console.log('🎯 [Ticket Component] VM creation completed event received:', event);
    console.log(`📋 [Ticket Component] Ticket ID: ${event.ticketId}, VM: ${event.vmName}, Success: ${event.success}`);

    if (event.success) {
      console.log('✅ [Ticket Component] VM creation succeeded, refreshing ticket data...');

      // Refresh ticket data to show updated VDI status
      this.refreshTicketData();

      // Reset create VM button cache since VM creation status changed
      this.resetCreateVmButtonCache();

      // Show success message
      this.message.success(`VM "${event.vmName}" has been created successfully!`);
    } else {
      console.log('❌ [Ticket Component] VM creation failed');
      this.message.error(`VM creation failed for ticket ${event.ticketId}`);
    }
  }

  async createVm(): Promise<void> {
    // Start VM creation directly - warning banner will be displayed during process
    // Convert logic from test-direct-provisioning-now.ps1
    // 1) Health check; 2) Send direct provisioning request
    this.isCreateVmLoading = true;
    this.isVmCreationInProgress = true;
    this.message.info('Starting VM creation (direct provisioning)...');

    console.log('🔧 [Ticket] Create VM button clicked - current state:', {
      ticketId: this.ticketId,
      isVDITicket: this.isVDITicket(),
      isVmApproved: this.isVmApproved(),
      isVmCreated: this.isVmCreated,
      canShowCreateVmButton: this.canShowCreateVmButton(),
      isLoading: this.isCreateVmLoading
    });

    // Health check
    try {
      await firstValueFrom(this.vdiService.getHealthStatus());
    } catch (err) {
      this.message.error('Backend is not running. Please start it first.');
      this.isCreateVmLoading = false;
      this.isVmCreationInProgress = false;
      return;
    }

    // Build request payload (aligned with PowerShell script)
    const vdiRequest: any = {
      username: this.ticketForm?.get('email')?.value || this.userInfo?.userPrincipalName || 'test.user@vtc.edu.hk',
      access_token: 'vdi-moodle-integration-key-2025',
      startDateTime: '1735689600',
      endDateTime: '1735718400',
      gpurequirement: false,
      software: 'Python 3.11, VS Code',
      justification: 'Testing direct provisioning from UI',
      Comments: this.ticketForm?.get('resolutionComments')?.value?.trim() || 'Create VM from ticket page (direct provisioning)',
      directProvision: true,
      serviceDescription: 'VDI Virtual Desktop',
      softwareSet: 'python-dev',
      // Ensure backend receives ticket identifier(s)
      ticketNumber: this.ticketNo || this.ticketForm?.get('ticketNo')?.value || '',
      ticketNo: this.ticketNo || this.ticketForm?.get('ticketNo')?.value || ''
    };

    // Send the request
    try {
      const response: any = await firstValueFrom(this.vdiService.testVdiRequest(vdiRequest));
      const isSuccess = (response?.result ?? false) || (response?.data?.success ?? false) || (response?.success ?? false);
      if (isSuccess) {
        this.isVmCreated = true;
        this.isVmDetailsLoading = true;
        this.loadVmDetails('createVm');
        this.message.success('✅ Direct provisioning request submitted successfully');
        // Optionally refresh VM status UI components
        this.refreshTicketData();
      } else {
        const msg = response?.message || response?.data?.message || response?.error || 'Unknown failure';
        this.message.warning(`⚠️ Direct provisioning failed: ${msg}`);

        // Fallback: if we have a ticketId, try triggering via approval workflow
        if (response?.ticketId) {
          try {
            this.message.info('Attempting to trigger VM creation via approval workflow...');
            const approveResp = await firstValueFrom(
              this.vdiApprovalService.approveTicket(String(response.ticketId), {
                comments: 'Direct provisioning failed; triggering approval from ticket page',
                vmSize: undefined,
                region: undefined
              })
            );
            this.message.success(approveResp?.message || 'Approval triggered, VM creation started');
            this.refreshTicketData();
          } catch (approveErr: any) {
            this.message.error(`Failed to trigger approval workflow: ${approveErr?.message || 'Unknown error'}`);
          }
        }
      }
    } catch (error: any) {
      this.message.error(`❌ Request failed: ${error?.message || 'Unknown error'}`);
    } finally {
      this.isCreateVmLoading = false;
      this.isVmCreationInProgress = false;
    }
  }

  /**
   * Refresh current ticket data to show updated VDI status
   */
  refreshTicketData(): void {
    if (this.ticketId) {
      console.log('🔄 [Ticket Component] Refreshing ticket data for ID:', this.ticketId);

      // Get fresh ticket data from service
      firstValueFrom(this.ticketService.getTicketInfo(this.ticketId.toString())).then(
        (ticketData: any) => {
          console.log('✅ [Ticket Component] Ticket data refreshed successfully');

          // Update local ticket info
          this.ticketInfo = ticketData;

          // Update form if needed
          if (ticketData?.ticket) {
            this.ticketForm.patchValue({
              subCategoryID: ticketData.ticket.subCategoryID,
              detail: ticketData.ticket.detail
            });
          }

          this.resetVDITicketCache();
          this.evaluateApproveButtonState();
          this.resetCreateVmButtonCache(); // Reset create VM button cache when ticket data refreshes
          this.loadVmDetails('refreshTicketData');
        },
        (error) => {
          console.error('❌ [Ticket Component] Error refreshing ticket data:', error);
          this.message.error('Failed to refresh ticket data');
        }
      );
    }
  }

  /**
   * Browser beforeunload event handler
   * Shows native browser warning when user tries to close during VM creation
   */
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: any): any {
    if (this.isVmCreationInProgress) {
      const warningMessage = 'The VM creation process is running. Please do not close the browser.';
      event.preventDefault();
      event.returnValue = warningMessage;
      return warningMessage;
    }
  }

  // ✅ Fix: ngOnDestroy to prevent memory leaks (cleanup subscriptions)
  /**
   * Check if the current problem category is "Azure VDI"
   */
  isAzureVDICategory(): boolean {
    const categoryID = this.ticketForm.get('categoryID')?.value;
    if (!categoryID) {
      return false;
    }

    const category = this.problemCategoryList.find(cat => cat.id === categoryID);
    if (!category) {
      return false;
    }

    const categoryDescr = (this.lang === 'en' ? category.categoryDescrEng : category.categoryDescrChi) || '';
    return categoryDescr.toLowerCase().includes('azure vdi') || categoryDescr.toLowerCase().includes('azure virtual desktop');
  }

  ngOnDestroy(): void {
    // Cleanup language change subscription
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
      this.langChangeSubscription = null;
      console.log('🌐 [Ticket] Language change subscription cleaned up');
    }

    this.destroy$.next();
    this.destroy$.complete();

    // Clear any timers
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

}
